import React from 'react'
import axios from 'axios'
import { Element, Link } from 'react-scroll'


export {
    React,
    axios,
    Element,
    Link
}

export * from 'react'
export * from 'axios'
export * from 'react-scroll'
